import React, {useEffect, useState} from "react";
import {Box, Card, Typography} from "@mui/material";
import Stack from "@mui/material/Stack";
import styled from "@emotion/styled";
import Span from "@jumbo/shared/Span";
import ArchiveCard from "./ArchiveCard";
import {axios_tenant} from "../../../axios";


const QC_Archives = ()=>{

    const [archiveData, setArchiveData] = useState([]);

    //id,publicationNo,noOfErrors,result,runOn,packageUrl, userId, 

    const userId = localStorage.getItem("TENANT_USER_ID");

    const archiveInfo = [
        {"userId": "1", "publicationNo" : "ERT6", "noOfErrors" : "2", "runOn": "Date 1","action" : "link 1"},
        {"userId": "2", "publicationNo" : "TEDD", "noOfErrors" : "3", "runOn": "Date 3","action" : "link 2"},
        {"userId": "3", "publicationNo" : "FSDF", "noOfErrors" : "4", "runOn": "Date 2","action" : "link 3"},
        {"userId": "4", "publicationNo" : "WERW", "noOfErrors" : "8", "runOn": "Date 4","action" : "link 4"},
    ]

    // setArchiveData(archiveInfo);

    useEffect(()=>{
        getArchiveData();
    },[])

    const getArchiveData = () =>{
        axios_tenant.get(`/qc/archive`)
        .then((res) =>{
            setArchiveData(res.data);
        })
        .catch((error) =>{
        })

    }


    const Item = styled(Span)(({theme}) => ({
        padding: theme.spacing(0, 0),
    }));

    return (
        <>
        <Box display="flex" justifyContent="center" alignItems="center" >

        
         <Card sx={{mb: 1, width: {xs:1.0,md:900,sm:250},position:"fixed", mt:2}} variant={"outlined"}>
                <Stack direction={"row"} alignItems={"center"}  spacing={14} sx={{p: theme => theme.spacing(1, 2)}} > 
                {/*  */}
                       {/* <Item
                       ,
                            sx={{
                                flex: {xs: 1, md: '0 1 45%', lg: '0 1 35%'},
                                alignSelf: 'flex-center',
                                flexBasis: {md: '28%', lg: '18%'},
                                display: {xs: 'none', md: 'block'}
                            }}
                   
                        >
                            <Typography variant={"h2"} mt={1} lineHeight={1.25}>User Id</Typography>
                           
                        </Item> */}

                        <Item
                            sx={{
                       
                                flex: {xs: 1, md: '0 1 45%', lg: '0 1 35%'},
                                alignSelf: 'flex-start',
                                flexBasis: {md: '28%', lg: '18%'},
                                display: {xs: 'none', md: 'block'}
                            }}
                   
                        >
                            <Typography variant={"h4"} mt={1} lineHeight={1.25}>Application No.</Typography>
                           
                        </Item>

                        <Item
                           sx={{
                       
                            flex: {xs: 1, md: '0 1 45%', lg: '0 1 35%'},
                            alignSelf: 'flex-start',
                            flexBasis: {md: '28%', lg: '18%'},
                            display: {xs: 'none', md: 'block'}
                        }}
                   
                        >
                            <Typography variant={"h4"} mt={1} lineHeight={1.25}>Number of Errors</Typography>
                           
                        </Item>

                        <Item
                           sx={{
                       
                            flex: {xs: 1, md: '0 1 45%', lg: '0 1 35%'},
                            alignSelf: 'flex-start',
                            flexBasis: {md: '28%', lg: '18%'},
                            display: {xs: 'none', md: 'block'}
                        }}
                   
                        >
                            <Typography variant={"h4"} mt={1} lineHeight={1.25}>Time of QC Run</Typography>
                           
                        </Item>

                        <Item
                           sx={{
                       
                            flex: {xs: 1, md: '0 1 45%', lg: '0 1 35%'},
                            alignSelf: 'flex-start',
                            flexBasis: {md: '28%', lg: '18%'},
                            display: {xs: 'none', md: 'block'},

                        }}
                   
                        >
                            <Typography variant={"h4"} mt={1} lineHeight={1.25}>Downloads</Typography>
                           
                        </Item>      

                        
                        
                </Stack>
            </Card>
        </Box>

        

        <Box display="flex" flexDirection="column" alignItems="center" sx={{mt:5}} >
            {(archiveData && archiveData.length > 0) && archiveData.map((p, i) => (
            <ArchiveCard archiveItem={p} key={p.id} />
            ))}
        </Box>


        </>

    )
}

export default QC_Archives;